import React from 'react';
import useTextOverlayFontStyles from 'blocks/TextOverlayModal/v2/hooks/useTextOverlayFontStyles';
import AnimationColorSelector from '../../AnimationColorSelector';

export interface ActiveLineScrollAnimationActiveLineColorSelectorProps {}

const ActiveLineScrollAnimationActiveLineColorSelector: React.FC<ActiveLineScrollAnimationActiveLineColorSelectorProps> = () => {
  const { selectedFontColor, onChangeFontColor } = useTextOverlayFontStyles();

  return (
    <AnimationColorSelector
      title="active line color"
      color={selectedFontColor}
      onChange={onChangeFontColor}
    />
  );
};

export default ActiveLineScrollAnimationActiveLineColorSelector;
